export default {
	hookPrefix: 'slide-item',
};
